import {
  Box,
  SimpleGrid,
} from "@chakra-ui/react";

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaFileContract, FaHome, FaUserTimes } from "react-icons/fa";
import { FaUser, FaUserCheck } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { useEffect } from "react";
import { getAdmins, getAdminManager, getExpiredAdmins, getDashboardCounts } from "../../../redux/actions/SuperAdmin.action";
import TotalLeadsChart from "components/charts/TotalLeadsChart";

// ... rest of the code remains the same

// ... rest of the code remains the same
export default function UserReports() {
  const superAdminData = useSelector((state) => state.superAdmin)
  const counts = superAdminData?.dashboardCounts?.data;
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDashboardCounts())
  }, [])


  return (
    <>
      <div className="mt-[100px]"></div>
      <Box pt={{ base: "20px", md: "40px", xl: "50px" }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3, "2xl": 4 }}
          gap='20px'
          mb='20px'>
          <Link to={"/superadmin/alladminusers"}>
            <MiniStatistics
              bgColor="#FFD580"
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<FaUser className="text-[24px]" />}
                />
              }
              name='Total Admin'
              value={counts?.activeAdmin + counts?.expiredAdmin || 0}
            />
          </Link>

          <Link to={"/superadmin/activeadminusers"}>
            <MiniStatistics
              bgColor="#A0E7E5" 
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<FaUserCheck className="text-[24px]" />}
                />
              }
              name='Total Active Admin'
              value={counts?.activeAdmin || 0}
            />
          </Link>

          <Link to={"/superadmin/expiredadminusers"}>
            <MiniStatistics
              bgColor="#C1F0C1" 
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<FaUserTimes className="text-[24px]" />}
                />
              }
              name='Total Expired Admin'
              value={counts?.expiredAdmin || 0}
            />
          </Link>

          <Link to={"/superadmin/plans"}>
            <MiniStatistics
              bgColor="#D6D6F5" 
              startContent={
                <IconBox
                  w='56px'
                  h='56px'
                  className='text-theme-dark bg-[#E6EFF7]'
                  icon={<FaFileContract className="text-[24px]" />}
                />
              }
              name='Total Plan'
              value={counts?.totalPlans || 0}
            />
          </Link>

        </SimpleGrid>
      </Box>
      <Box>
        {/* <TotalLeadsChart /> */}
      </Box>
    </>
  );
}
